export default "__VITE_ASSET__yMCfvbaj__"